import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "messageList", "form", "input", "submitBtn", "showTools", "toolsCheckbox"]

  connect() {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => this.scrollToBottom())
    if (this.hasMessageListTarget) {
      this.observer.observe(this.messageListTarget, { childList: true })
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  send(event) {
    const message = this.inputTarget.value.trim()
    if (!message) {
      event.preventDefault()
      return
    }

    // Show loading state — only disable submit button, NOT the input
    // (Turbo needs the input enabled to read form data)
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>'

    // Append loading indicator
    const loading = document.createElement('div')
    loading.id = 'chat-loading'
    loading.className = 'chat-message chat-message--assistant'
    loading.innerHTML = '<div class="chat-bubble chat-bubble--loading"><span class="typing-dots"><span>.</span><span>.</span><span>.</span></span></div>'
    this.messageListTarget.appendChild(loading)
    this.scrollToBottom()

    // Disable input after a microtask so Turbo captures the value first
    setTimeout(() => { this.inputTarget.readOnly = true }, 0)

    // Let Turbo handle the form submission naturally
  }

  // Called when Turbo finishes the form submission
  formComplete() {
    const loadingEl = document.getElementById('chat-loading')
    if (loadingEl) loadingEl.remove()

    this.inputTarget.value = ''
    this.inputTarget.readOnly = false
    this.submitBtnTarget.disabled = false
    this.submitBtnTarget.innerHTML = 'Send'
    this.inputTarget.focus()
    this.scrollToBottom()
  }

  toggleTools() {
    this.showToolsTarget.value = this.toolsCheckboxTarget.checked ? "1" : "0"
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }
}
